import { BCMSRecord, DisabledPrompt, useBCMSContext, useParams, useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from 'components/shared/containers/FormContainer';
import { MainContentSection } from 'components/shared/containers/MainContentContainer';
import CustomSelect, { CustomSelectItem } from "components/ui/CustomSelect";
import UIAmountInput from 'components/ui/UIAmountInput';
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UIRadio from 'components/ui/UIRadio';
import { getDefault, getWorkflowSteps } from "components/workflows/AutoPayWorkFlow";
import { Card, LinkedAccount, Transaction } from "model";
import React, { useState } from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function EnterAutopayView
 * @param {STRING} acctType - This sets the account type in the custom select item.
 * @param {STRING} acctNum - Sets the account number in the custom select item.
 * @param {STRING} fiName - Sets the FI name in the custom select item.
 * @return {React.Component}
 * @exported true
 * @description The main component for EnterAutopayView and the first step in the autopay workflow.
 */
export default function EnterAutopayView(props) {
    const globalController = useBCMSContext();
    const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
    const cardID = useParams().cardID ?? defaultCard;
    const card = Card.initByID(cardID);
    const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
    BCMSRecord.globalControllerFor([ Card ,LinkedAccount,Transaction ], globalController);
    const accounts = LinkedAccount.initAll().reduce((accounts,account)=>{
        if(account.type !== "credit" && account.status === "active" && account.id === "0"){
            accounts.push( <CustomSelectItem value={account.id} >{`${account.type} ${account.last_four_digit_number} - ${account.fi_name}`}</CustomSelectItem>)
        }
       return accounts;
    },[]);
    const [getCustomAmount ,setCustomAmount] = useState("");
    const [selectRadio ,setSelectRadio] = useState(false);
    let defaultAmountSelect = workflowStep.getStepState.amountSelect?? "Minimum Payment Due";
    const updateSelect = ()=>{
        setSelectRadio(true)
        workflowStep.update([ "amountSelect" ], "Custom Amount");

    };
      const updateAmount =  (selected,amount)=>{
        setSelectRadio( amount !== "Minimum Payment Due" && amount !== "Statement Balance");
             workflowStep.update([ "amountSelect" ],amount);
      };
      const updateAccount = account=>{
        workflowStep.update([ "account" ],account);
      };
    
  
    const navigate = useRoute();


    const minAmount = card.minPaymentAmount.format() ?? "[$xx.xx]";
    const dateDue = card.dateDue.format("M d") ?? "[Mon dd]";
    const statementBalance = card.statementBalance.format() ?? "[$xx.xx]";
    const statementDate = card.lastStatementDate.format("M d") ?? "[Mon dd]";
    const currentBalance = card.statementBalance.format() ?? "[$xx.xx]";
    const acctType = card.acctType ?? "[account type]";
    const acctNum = card.acctNum ?? "[account number]";
    const fiName = card.fiName ?? "[FI Name]";

    const next = evt => {
        let amount ="100";
        let amountSelect = workflowStep.getStepState.amountSelect ?? "Minimum Payment Due" ;
        switch(workflowStep.getStepState.amountSelect){
            case "Minimum Payment Due":
                amount=minAmount;
                break;
            case "Statement Balance":
                amount=statementBalance;
                break;
            case "Current Balance":
                amount=currentBalance;
                break;  
                case undefined:
                    amountSelect =  "Minimum Payment Due"
                    amount=minAmount;    
                break;        
            default:  
            amountSelect = "Custom Amount"
            amount=getCustomAmount === "0.00"?minAmount:getCustomAmount ;         
        }
       
        workflowStep.update([ "amountSelect" ],amountSelect);
        workflowStep.update([ "amount" ],amount);
        workflowStep.workflow.nextStep( workflowStep.getStepState);
    };
 
    return (
        <div className="enter-autopay-view">
            <FormContainer >
                <MainContentSection text="Amount">
                    <FormRow className="minimum-payment-due-row">
                        <UIRadio name="payment-option" label="Minimum Payment Due"  onChange={updateAmount} value={defaultAmountSelect === "Minimum Payment Due"}/>
                    </FormRow>
                    <FormRow className="statement-balance-row">
                        <UIRadio name="payment-option" label="Statement Balance"  onChange={updateAmount} value={defaultAmountSelect === "Statement Balance"}/>
                    </FormRow>
                    <FormRow className="custom-amount-row">
                    <UIRadio label={<UIAmountInput placeholder="Custom Amount"  value={getCustomAmount} onBlur={setCustomAmount} onClick={updateSelect}/>} value={selectRadio} name="payment-option"  onChange={updateAmount}/>
                </FormRow>
                </MainContentSection>
                <MainContentSection text="Account">
                    <FormRow className="payment-account-row capitalize">            
                    <DisabledPrompt>    
                        <CustomSelect label="Payment Account" value="0" onChange={updateAccount}>
                       {accounts}
                        </CustomSelect>
                    </DisabledPrompt>

                    </FormRow>
                    <div className="flex-container flex-horizontal align-center-container info-container">
                        <div className="set-width left-icon-container">
                            <SVGAsset id="InformationIcon" />
                        </div>
                        <div className="flex-width">
                            <span className="sub-text">Payments can be scheduled up to XX days in advanced.</span>
                        </div>
                    </div>
                    <FormButtonContainer>
                        <UIPrimaryButton text="Schedule" onClick={next} />
                        <UICancelButton onClick={() => {navigate("/home/payments/1")}} text="Cancel" />
                    </FormButtonContainer>
                </MainContentSection>
            </FormContainer>
        </div>
    )
}
